import React from "react";
const SajariMetaForArticle = ({ article }) => (<div>
		<span data-sj-meta-title={article.get("title")}/>
		<span data-sj-meta-category={article.getIn(["category_id", "name"])}/>
		<span data-sj-meta-slug={article.get("slug")}/>
		<span data-sj-meta-eventid={article.get("_id")}/>
		<span data-sj-meta-model="article"/>
		<span data-sj-meta-image={article.get("horizontalImageCover")}/>
		<span data-sj-meta-tagids={article
        .get("tags")
        .map(t => t.get("tag_id"))
        .join(";")}/>
		<span data-sj-meta-interesttagids={article
        .get("tags")
        .filter(t => t.get("is_primary_interest"))
        .map(t => t.get("tag_id"))
        .join(";")}/>
	</div>);
export default SajariMetaForArticle;
